import {PAGE_CREATE} from '../constant/eventbus'
import {get_act_stat} from '../api'
import {isUndefined} from '../tools/typeof'
import {error_event} from '../tools/mgtv/analysis'
import setTitle from '../tools/set-title'
import {setShare} from '../tools/mgtv/share'
import {getTplValue, processComp} from '../tools/tpl'
import {isObject} from '../tools/typeof'

export default {
  install: function (EventBus) {
    EventBus.$on(PAGE_CREATE, () => {

      //获取活动状态
      get_act_stat().then(res => {
        if (!res) {
          if (!gact.auto_login) {
            window.$toast('获取活动状态失败');
          } else {
            //自动登陆时会跳转走，会导致这个接口发生错误。让这个消息晚一点出现。
            setTimeout(() => {
              window.$toast('获取活动状态失败');
            }, 1500);
          }
          return;
        }
        if (res.ret === 0 && !isUndefined(res.data.is_start)) {
          EventBus.$set(EventBus.act, 'act_stat', res.data.is_start);
          if (res.data.is_start === 2) {
            window.$toast("活动已结束");
          } else if (res.data.is_start === 0) {
            window.$toast("活动即将开始,敬请期待");
          }

          //活动中文名称
          window.rootdata.act_name_chn = res.data.act_name_chn;

          const tpl = res.data.tpl;
          if (!tpl || !tpl.page) {
            window.$toast('无页面配置信息');
            return;
          }

          if (!tpl.comps) {
            tpl.comps = []
          }

          //处理数值，交给后端处理后可以删除 ,将Object类型的mvalue转换为value
          // for (let k in tpl.page) {
          //   if (isObject(tpl.page[k]) && tpl.page[k].mvalue) {
          //     tpl.page[k] = getTplValue(tpl.page[k])
          //   }
          // }
          //
          // tpl.comps.forEach(comp => {
          //   for (let k in comp) {
          //     if (k !== 'action_info') {
          //       if (isObject(comp[k]) && comp[k].mvalue) {
          //         comp[k] = getTplValue(comp[k]);
          //       }
          //     } else {
          //       //action_info中的属性
          //       for (let j in comp[k]) {
          //         if (isObject(comp[k][j]) && comp[k][j].mvalue) {
          //           comp[k][j] = getTplValue(comp[k][j])
          //         }
          //       }
          //     }
          //   }
          // });


          tpl.comps.forEach(comp => {
            processComp(comp);
          });

          // console.log(tpl);

          window.$bus.tpl = tpl;
          const title = tpl.page.title;
          if (title) {
            if(gact.f_release === '0'){
              setTitle('(预览)'+title);
            }else{
              setTitle(title);
            }
          }

          let share_title = tpl.page.share_title;
          let share_desc = tpl.page.share_desc;
          let share_img = tpl.page.share_img;
          if (share_title && share_img) {
            setShare({
              title: share_title,
              desc: share_desc,
              img: share_img,
            })
          }
        } else {
          window.$toast('获取活动状态失败');
        }
      })
    });


  }
}





// WEBPACK FOOTER //
// ./src/EventBus/EventAct.js